'use client'
import React from 'react'
import HeadingWithNumberedSubHeadings from '@/UI/Paragraph/HeadingWithNumberedSubHeadings'
import HeadingWithParagraphs from '@/UI/Paragraph/HeadingWithParagraphs'
import { Typography, styled } from '@mui/material'
import MuiAccordion from '@/UI/MUI/Accordion/Accordion'
import { carFinanceAccordionData, carFinanceCalculatorText, whatCanIDoNextData } from './Content'
import HeadingWithList from '@/UI/Paragraph/HeadingWithList'

export const InformationWrapper = styled('div')(({ theme }) => ({
  marginBottom: theme.spacing(5),
  [theme.breakpoints.up('lg')]: {
    marginBottom: theme.spacing(7)
  }
}))

const LeftColumn: React.FC = () => {
  return (
    <>
      <HeadingWithNumberedSubHeadings
        content={carFinanceCalculatorText}
        centerHeader
        styleOverRides={{ marginTop: '30px' }}
      />
      <HeadingWithList title="What can I do next?" sectionData={whatCanIDoNextData} />
      <HeadingWithParagraphs
        centerHeader
        title="What length of loan is right for you?"
        paragraphs={[
          "How long your car finance agreement should last, and how much you'd like to repay each month, depends very much on your personal circumstances and what you can afford. It's worth thinking forward to see if you think you'll have other major costs during the loan period, such as a house purchase",
          'Paying the loan off over a shorter period such as two years will mean larger monthly repayments, but will also reduce the total sum you pay back. Paying less each month over a longer period of time may make your payments more affordable, but the total amount you pay (see our APR example at the top of the page) will increase. To summarise, longer loan lengths can help reduce monthly payments but will cost more overall due to interest. Shorter loan lengths will come with higher monthly repayments, but cost less overall.',
          'You can tweak the options in our car loan calculator to find a monthly cost that works for you.'
        ]}
      />
      <Typography variant="h2" textAlign="center">
        What costs should I think about?
      </Typography>
      <Typography variant="body1" mb={3}>
        The most important thing when buying a car is to know what you can afford. When using our
        car finance calculator, it&apos;s useful to think about ongoing costs that might impact what
        you can afford to pay every month.
      </Typography>
      <ul>
        <li>Insurance: Car insurance is a legal requirement.</li>
        <li>Road Tax: While some cars don&apos;t incur tax, many do.</li>
        <li>Maintenance: Factor in MOT&apos;s and running repairs.</li>
        <li>Ongoing running costs: Everything from petrol to windscreen washer fluid.</li>
      </ul>
      <InformationWrapper>
        <Typography variant="h3" align="center">
          Car finance calculator FAQs
        </Typography>
        <MuiAccordion accordionData={carFinanceAccordionData} />
      </InformationWrapper>
    </>
  )
}

export default LeftColumn
